import * as R from 'ramda';

import sportsApi from '../../utils/sportsApi';
import { normalize, schema } from 'normalizr';

const socialAccountsList = new schema.Entity('socialAccountsList', undefined, {
    idAttribute: value => {
        return value.account.platformUserId;
    },
});

const saveIgAccounts =
    store => async (state, clientId, clientAuthorizedAccount) => {
        const userClientId = state.user.selectedUserClientId;

        const response = await sportsApi
            .url(`/clients/${clientId}/authorized-accounts`)
            .json(clientAuthorizedAccount)
            .post()
            .json();

        const normalizedData = normalize(response, [socialAccountsList]);

        const existinginAccounts = R.clone(
            store.getState().clients[userClientId].socialAccounts.instagram
                .linkedAccounts,
        );
        const accounts = R.merge(
            normalizedData.entities.socialAccountsList,
            existinginAccounts,
        );

        store.setState(
            R.evolve(
                {
                    clients: {
                        [userClientId]: {
                            socialAccounts: {
                                instagram: {
                                    linkedAccounts: R.always(accounts),
                                },
                            },
                        },
                    },
                },
                store.getState(),
            ),
            true,
        );
    };

export default saveIgAccounts;
